<nz-spin [nzSpinning]="loading">
  <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="submitForm()">
    @if (isEdit && isAvatarValue()) {
      <div class="avatar-container">
        <app-avatar
          [sizePx]="160"
          [fullName]="{ firstName: form.get('firstName').value, lastName: form.get('lastName').value }"
        ></app-avatar>
        <app-login-qr-code
          [badgeSvg]="rawBadgeSvg"
          [userLabel]="userLabel"
          [documentKey]="editObject?.documentKey || null"
        ></app-login-qr-code>
      </div>
    }

    <nz-form-item>
      <nz-form-label nzFor="login" nzRequired>
        <span>Benutzername</span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="requiredMsg('Benutzername')" nzExtra="Wie sollen sich andere anmelden?">
        <input nz-input id="login" formControlName="login" autocomplete="username" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="firstName" nzRequired>
        <span>Vorname</span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="requiredMsg('Vorname')">
        <input nz-input id="firstName" formControlName="firstName" autocomplete="given-name" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="lastName" nzRequired>
        <span>Nachname</span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="requiredMsg('Nachname')">
        <input nz-input id="lastName" formControlName="lastName" autocomplete="family-name" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="email">
        <span>E-Mail</span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="invalidEmailMsg()">
        <input nz-input type="email" id="email" formControlName="email" autocomplete="email" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="phone">
        <span>Telefonnummer</span>
      </nz-form-label>
      <nz-form-control>
        <input nz-input type="tel" id="phone" formControlName="phone" autocomplete="tel" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="role" nzRequired>
        <span>Rolle</span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="requiredMsg('Rolle')">
        <nz-select id="role" formControlName="role">
          @for (role of roles; track role) {
            <nz-option [nzValue]="role" [nzLabel]="role | roleLabel"></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="position" nzRequired>
        <span>Berufsbezeichnung</span>
      </nz-form-label>
      <nz-form-control [nzErrorTip]="requiredMsg('Berufsbezeichnung')">
        <input nz-input id="position" formControlName="position" autocomplete="organization-title" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="isProduction">
        <span>Produktion</span>
      </nz-form-label>
      <nz-form-control>
        <label nz-checkbox formControlName="isProduction" id="isProduction"></label>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzFor="canEditRecipes">
        <span>Rezepturen bearbeiten</span>
      </nz-form-label>
      <nz-form-control>
        <label nz-checkbox formControlName="canEditRecipes" id="canEditRecipes"></label>
      </nz-form-control>
    </nz-form-item>
  </form>
</nz-spin>

<ng-template #confirmModalContent>
  <p>Passwort wurde bereits generiert: <strong>{{currentPassword}} </strong><br><br>
  Sie können eine kurze Anleitung per E-Mail <a [href]="currentMailTo"><strong>hier</strong></a> senden.</p>
</ng-template>

<ng-template #confirmResetModalContent>
  <p>Neues Passwort wurde bereits generiert: <strong>{{currentPassword}} </strong><br><br>
  Sie können eine kurze Anleitung per E-Mail <a [href]="currentMailTo"><strong>hier</strong></a> senden.</p>
</ng-template>
